/* ═══════════════════════════════════════════════
   東京Lily — コレクション一覧ページ
   絞り込み・並び替え（C-04）: select / 価格入力の変更で GET 送信
   （フィルタは Shopify Search & Discovery の filter.* パラメータ、並び替えは sort_by ネイティブ）
═══════════════════════════════════════════════ */
(function () {
  'use strict';

  /* カテゴリー／特典の遷移: 並び替え・価格などの現在パラメータを引き継ぐ（page / view は除外） */
  function navigate(target) {
    var url = new URL(target, location.origin);
    new URLSearchParams(location.search).forEach(function (v, k) {
      if (k === 'page' || k === 'view' || url.searchParams.has(k)) return;
      url.searchParams.append(k, v);
    });
    location.href = url.pathname + url.search;
  }

  document.querySelectorAll('[data-tl-nav]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      if (sel.value) navigate(sel.value);
    });
  });

  document.querySelectorAll('[data-tl-nav-link]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      navigate(a.getAttribute('href'));
    });
  });

  document.querySelectorAll('[data-tl-filter-form]').forEach(function (form) {
    function submitClean() {
      /* 空値のコントロールは URL を汚さないよう送信前に disable する */
      form.querySelectorAll('select, input').forEach(function (c) {
        if (c.name && c.value === '') c.disabled = true;
      });
      form.submit();
    }

    form.querySelectorAll('[data-tl-autosubmit]').forEach(function (el) {
      el.addEventListener('change', submitClean);
    });

    /* 価格入力は Enter でも送信 */
    form.querySelectorAll('input[type="number"]').forEach(function (el) {
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          submitClean();
        }
      });
    });
  });
})();
